export default function Footer() {
  const scrollTo = (href: string) => {
    document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-gray-100 text-gray-500 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <img
              src="https://ilkeismakinalari.com/img/ilke-logo.png"
              alt="İlke İş Makinaları"
              className="h-16 w-auto object-contain mb-4"
            />
            <p className="text-sm leading-relaxed text-gray-500">
              25 yıllık tecrübemizle iş makinaları yedek parça tedarikinde güvenilir çözüm ortağınız.
            </p>
          </div>

          <div>
            <h4 className="text-gray-900 font-black text-xs uppercase tracking-[0.2em] mb-5">Kurumsal</h4>
            <ul className="space-y-3">
              {[
                { label: 'Hakkımızda', href: '#hakkimizda' },
                { label: 'Markalarımız', href: '#markalar' },
                { label: 'Hizmetlerimiz', href: '#hizmetler' },
                { label: 'İletişim', href: '#iletisim' },
              ].map((link) => (
                <li key={link.label}>
                  <a href={link.href} onClick={(e) => { e.preventDefault(); scrollTo(link.href); }}
                    className="text-sm hover:text-orange-500 transition-colors cursor-pointer">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-gray-900 font-black text-xs uppercase tracking-[0.2em] mb-5">Yedek Parça</h4>
            <ul className="space-y-3">
              {['Motor Parçaları', 'Hidrolik Sistemler', 'Filtreler', 'Elektrik & Elektronik', 'Şasi & Gövde', 'Aktarma Organları'].map((item) => (
                <li key={item}>
                  <a href="#yedek-parca" onClick={(e) => { e.preventDefault(); scrollTo('#yedek-parca'); }}
                    className="text-sm hover:text-orange-500 transition-colors cursor-pointer">
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-gray-900 font-black text-xs uppercase tracking-[0.2em] mb-5">İletişim</h4>
            <ul className="space-y-4">
              {[
                { icon: 'ri-phone-line', text: '+90 536 432 25 18' },
                { icon: 'ri-phone-line', text: '+90 531 704 35 57' },
                { icon: 'ri-mail-line', text: 'info@ilkeismakinalari.com' },
                { icon: 'ri-map-pin-line', text: 'Cevahir Sk. No:14A, Sancaktepe/İstanbul' },
                { icon: 'ri-time-line', text: 'Pzt-Cum: 08:00 - 18:00' },
              ].map((item) => (
                <li key={item.text} className="flex items-start gap-3">
                  <div className="w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className={`${item.icon} text-orange-500 text-sm`}></i>
                  </div>
                  <span className="text-sm text-gray-500">{item.text}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-gray-200">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-gray-400">
            © 2025 ilkeismakinalari.com — Tüm hakları saklıdır.
          </p>
          <div className="flex items-center gap-4">
            {[
              { icon: 'ri-linkedin-box-line', label: 'LinkedIn' },
              { icon: 'ri-instagram-line', label: 'Instagram' },
              { icon: 'ri-whatsapp-line', label: 'WhatsApp' },
            ].map((social) => (
              <a key={social.label} href="#" aria-label={social.label} rel="nofollow"
                className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-orange-500 transition-colors cursor-pointer border border-gray-200 hover:border-orange-500/30 rounded-sm">
                <i className={`${social.icon} text-base`}></i>
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
